



































import { Component, Prop, Vue } from 'vue-property-decorator'
import { TileType } from '@/data/enums'
import '@/icons/rating-1'
import '@/icons/rating-2'
import '@/icons/rating-3'
import '@/icons/rating-smiley-1'
import '@/icons/rating-smiley-2'
import '@/icons/rating-smiley-3'

@Component({
  inheritAttrs: false,
  components: {
    RatingIconDefault: () => import('./icons/RatingIconDefault.vue')
  }
})
export default class RatingIcon extends Vue {
  @Prop({ default: 1 }) public value?: string | number
  @Prop({ default: TileType.Default }) public type?: string

  private get icon () {
    switch (this.type) {
      case TileType.Smiley:
        return 'rating-smiley'
      case TileType.Time:
      case TileType.Default:
      default:
        return 'rating'
    }
  }
}
